module.exports = __webpack_public_path__ + "img/sg.17f50844.svg";